export const FAQ_SLUG = "faqs";
